import { LegalStatusService } from '@/domains/legal-status/types/legal-status-service.interface';
import { injectService } from '@/inversify.config';
import { createSharedComposable } from '@vueuse/core';
import { legalSettings } from '@patsnap-utils/biz';
import { LegalStatusTypes } from '@/domains/legal-status/enum';
export const useLegalStatus = createSharedComposable(() => {
    const legalStatusService = injectService(LegalStatusService);
    const initLegalStatusConfig = () => {
        return legalStatusService.initLegalStatusConfig().then((legalStatusConfig) => {
            /**
             * 格式化legalStatus数据，并将数据更新到biz中，以便在biz中的组件使用
             */
            const legalList = legalStatusConfig;
            legalSettings(document, legalList);
        });
    };
    const getLegalStatusByCode = (code) => {
        return legalStatusService.getLegalStatusByCode(code, LegalStatusTypes.LEGAL_STATUS);
    };
    const getLegalEventByCode = (code) => {
        return legalStatusService.getLegalStatusByCode(code, LegalStatusTypes.LEGAL_EVENT);
    };
    const getLegalSimpleByCode = (code) => {
        return legalStatusService.getLegalStatusByCode(code, LegalStatusTypes.SIMPLE_LEGAL_STATUS);
    };
    const getLegalDataByCode = (code) => {
        return getLegalStatusByCode(code) || getLegalEventByCode(code);
    };
    return {
        initLegalStatusConfig,
        getLegalSimpleByCode,
        getLegalStatusByCode,
        getLegalEventByCode,
        getLegalDataByCode,
    };
});
